// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3tT1w","bigColWidth":"Table_bigColWidth__rRiJy","biggerColWidth":"Table_biggerColWidth__1KAVU","row":"Table_row__1h90x","col":"Table_col__22H1N"};